module.exports = new __parcel__URL__("77023_sq.39e6ecb2.jpg").toString();